import ApiService from "../ApiService";
const user = JSON.parse(localStorage.getItem("user"));

export default class CategoryService {
  static getModule = async (params) => {
    const instance = await ApiService();
    return instance.get("/module");
  };

  static getData = async (params) => {
    let num, cursor, property_id, tenant_id, keyword, type;

    if (params.num && params.num !== "") {
      num = `num=${params.num}`;
    }

    if (params.cursor && params.cursor !== "") {
      cursor = `&cursor=${params.cursor}`;
    }

    if (params.property_id && params.property_id !== "") {
      property_id = `&property_id=${params.property_id}`;
    }

    if (params.tenant_id && params.tenant_id !== "") {
      tenant_id = `&tenant_id=${params.tenant_id}`;
    }

    if (params.keyword && params.keyword !== "") {
      keyword = `&keyword=${params.keyword}`;
    }

    if (params.type && params.type !== "") {
      type = `&type=${params.type}`;
    }
    console.log(params);
    const instance = await ApiService();
    return instance.get(
      `/shopfront?${num || ""}${property_id || ""}${tenant_id || ""}${
        cursor || ""
      }${keyword || ""}`
    );
  };
  static getDataShopfront = async (params) => {
    let num, cursor, property_id, tenant_id, keyword, type;

    if (params.num && params.num !== "") {
      num = `num=${params.num}`;
    }

    if (params.cursor && params.cursor !== "") {
      cursor = `&cursor=${params.cursor}`;
    }

    if (params.property_id && params.property_id !== "") {
      property_id = `&property_id=${params.property_id}`;
    }

    if (params.tenant_id && params.tenant_id !== "") {
      tenant_id = `&tenant_id=${params.tenant_id}`;
    }

    if (params.keyword && params.keyword !== "") {
      keyword = `&keyword=${params.keyword}`;
    }

    if (params.type && params.type !== "") {
      type = `&type=${params.type}`;
    }

    const instance = await ApiService();
    return instance.get(
      `/master_category?${num || ""}${property_id || ""}${tenant_id || ""}${
        cursor || ""
      }${keyword || ""}`
    );
  };

  static storeData = async (value) => {
    const instance = await ApiService();
    const params = {
      name: value.name,
      type: value.type,
    };
    // debugger;
    return instance.post(`/shopfront`, params);
  };

  static putData = async (value) => {
    const instance = await ApiService();
    const params = {
      name: value.name,
      type: value.type,
    };
    return instance.put(`/shopfront/${value.id}`, params);
  };

  static deleteData = async (params) => {
    const instance = await ApiService();
    return instance.delete(`/shopfront/${params.id}`);
  };
}
